export default __webpack_public_path__ + "static/media/loop-mask-mobile.fd6bfaaf.svg";